import _ from 'lodash'
import { NonEmptyArray } from './types/utility'

export const removeArrayDuplicates = <T extends any>(arr: T[]) => {
  return Array.from(new Set(arr))
}

export const isNotDuplicate = <T extends any>(el: T, idx: number, arr: T[]) => {
  return arr.indexOf(el) === idx
}

export const isNonemptyArray = <T>(arr: T[] = []): arr is NonEmptyArray<T> => !!arr.length
export const isEmptyArray = <T>(arr: T[]): arr is [] => arr.length === 0

export function isNotEmptyElement<TValue>(
  value: TValue | null | undefined
): value is Exclude<TValue, null | undefined> {
  return value !== null && value !== undefined
}

export function countElements<T>(arr: T[] | undefined, predicate: (el: T) => boolean): number {
  // @ts-ignore
  return _.sumBy(arr ?? [], el => Number(predicate(el)))
}

export const isWithinFirstNElements =
  (n: number) =>
  (el: any, idx: number): boolean => {
    return idx < n
  }

export const getArrayOfNumbersFromOneToN = (n: number) => Array.from({ length: n }, (_, i) => i + 1)
